import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { CommentTableModel } from 'src/app/core/models/CommentTableModel';

@Component({
  selector: 'app-view-comments',
  standalone: false,
  templateUrl: './view-comments.component.html',
  styleUrl: './view-comments.component.less'
})
export class ViewCommentsComponent implements OnInit  {
  readonly nzModalData = inject(NZ_MODAL_DATA); 
  isTabularView: boolean = true;
  queryComments : any[] = [];
  queryReferenceNumber: string = ''; 
  commentTableModel: CommentTableModel[] = [];
  constructor(private datePipe: DatePipe) {}
  ngOnInit() {
    this.queryComments = this.nzModalData.queryComments;
    this.queryReferenceNumber = this.nzModalData.queryReferenceNumber;
    // Convert queryComments to commentTableModel
    this.commentTableModel = this.queryComments.map(comment => ({
      CommentedBy: comment.CommentedBy,
      Comment: comment.Comment,
      CommentedDate: new Date(comment.CommentedDate),
      CommentedDateTimeString: this.formatCommentedDate(comment.CommentedDate),
    }));
    
  }
  formatCommentedDate(commentedDate: string): string {
    return this.datePipe.transform(commentedDate, 'dd-MMM-yyyy HH:mm:ss a') || '';
  }
  toggleView() {
    this.isTabularView = !this.isTabularView;
  }
}
